const insertPickers = new Set()

export function registerInsertPicker(picker) {
  insertPickers.add(picker)
}

export function unregisterInsertPicker(picker) {
  insertPickers.delete(picker)
}

export function openEmblemPicker(anchor, onPick) {
  const picker = [...insertPickers].find((item) => item.element.isConnected)
  if (!picker) return false

  if (
    picker.tippyInstance?.state.isVisible &&
    picker.tippyReference === anchor
  ) {
    picker.close()
  } else {
    picker.open(anchor, onPick)
  }
  return true
}
